
import { AloDbMapLayer } from '@/models/alodb/AloDbMapLayer'
import { FilterBase } from '@/models/filter/FilterBase'

export interface IMapLayerState {
    status:string
    mapLayers: Array<AloDbMapLayer>
    modifiedAdmMapLayer: AloDbMapLayer
    originalAdmMapLayer: AloDbMapLayer
    mapLayerLoading: boolean
    adminFilter: FilterBase
}
  
const state:IMapLayerState = { 
    status: '',
    mapLayers: [],
    modifiedAdmMapLayer: new AloDbMapLayer(),
    originalAdmMapLayer: new AloDbMapLayer(),
    mapLayerLoading:false,
    adminFilter: new FilterBase()
}
  
export default state